<img [ngSrc]="src()" [alt]="header()" height="48" width="48" priority>

<h3 class="text-3 bold-2">{{ header() }}</h3>

<a routerLink="/services" [fragment]="fragment()">Learn more →</a>
